module.exports = __webpack_public_path__ + "img/WBPad-工具.90b6a578.svg";